{
  "SET_NEW_PASSWORD": {
    "TITLE": "Nastavit nové heslo",
    "PASSWORD": {
      "LABEL": "Heslo",
      "PLACEHOLDER": "Heslo",
      "ERROR": "Heslo je příliš krátké."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Potvrdit heslo",
      "PLACEHOLDER": "Potvrzení hesla",
      "ERROR": "Hesla se neshodují."
    },
    "API": {
      "SUCCESS_MESSAGE": "Heslo bylo úspěšně změněno.",
      "ERROR_MESSAGE": "Nelze se připojit k chat serveru, opakujte akci později"
    },
    "CAPTCHA": {
      "ERROR": "Ověření vypršelo. Vyřešte captchu znovu."
    },
    "SUBMIT": "Odeslat"
  }
}